function getDefaultApiBase() {
  if (typeof window === 'undefined' || !window.location) {
    return 'http://localhost:4000';
  }

  const { protocol, hostname } = window.location;
  if (!hostname || hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:4000';
  }

  // Falling through to `${hostname}:4000` below is only meant for local
  // network testing (e.g. opening the LAN IP on a phone).
  if (hostname === 'web.panenkuu.site') {
    return 'https://api.panenkuu.site';
  }

  return `${protocol}//${hostname}:4000`;
}

export const API_BASE = process.env.EXPO_PUBLIC_API_BASE || getDefaultApiBase();
